import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { tap } from 'rxjs/operators';
import { PayrollService } from '../payroll.service';
import { LoadConfiguration, LoadContractors, PayContractor, PayrollInit, UpdateContractorPayrollConfiguration, UpdatePayment } from './payroll.actions';

export type Category = {
  id: string
  name: string
}

export type Config = {
  contractor: {
    category?: Category
  }
}

export interface PayrollStateModel {
  contractors: any[];
  configuration?: any;
}

const defaults: PayrollStateModel = {
  contractors: [],
};

@State<PayrollStateModel>({
  name: 'payroll',
  defaults
})
@Injectable()
export class PayrollState {
  constructor(private payroll: PayrollService) {

  }

  @Action(PayrollInit)
  init({ dispatch }: StateContext<PayrollStateModel>) {
    return dispatch([
      new LoadConfiguration(),
      new LoadContractors(),
    ])
  }

  @Action(LoadConfiguration)
  loadConfiguration({ patchState }: StateContext<PayrollStateModel>) {
    return this.payroll.getSettings().pipe(
      tap((configuration) => {
        patchState({ configuration });
      })
    )
  }

  @Action(UpdateContractorPayrollConfiguration)
  updateConfiguration({ patchState, dispatch, getState }: StateContext<PayrollStateModel>, { config }: UpdateContractorPayrollConfiguration) {
    return this.payroll.updateContractorPayroll(config).pipe(
      tap((configuration) => {
        const { configuration: currenConfiguration } = getState();

        patchState({
          configuration: {
            ...currenConfiguration,
            ...configuration,
          }
        })
        dispatch([new PayrollInit()]);
      })
    )
  }

  @Action(LoadContractors)
  loadContractors({ patchState }: StateContext<PayrollStateModel>) {
    return this.payroll.getContractors().pipe(
      tap((contractors) => {
        patchState({ contractors });
      })
    )
  }

  @Action(PayContractor)
  addPayment({ }: StateContext<PayrollStateModel>, { payload }: PayContractor) {
    return this.payroll.addPayment(payload).pipe(
      tap((contractors) => {
        // patchState({ contractors });
      })
    )
  }

  @Action(UpdatePayment)
  updatePayment({ }: StateContext<PayrollStateModel>, { paymentId, payload }: UpdatePayment) {
    return this.payroll.updatePayment(paymentId, payload).pipe(
      tap((contractors) => {
        // patchState({ contractors });
      })
    )
  }


  @Selector()
  static contractors(state: PayrollStateModel) {
    return state.contractors
  }

  @Selector()
  static configuration(state: PayrollStateModel) {
    return state.configuration
  }
}
